<template>
  <div v-if="wine" class="wine-page">
    <AppButton size="xs" type="link" with-icon icon-position="left" text="Вернуться на главную" @click="selectPage('index')">
      <template #left><IconDefault name="chevron-left" size="s"/> </template>
    </AppButton>
    <div class="container">
      <div class="row first">
        <div class="row__item project-info">
          <p v-html="wine?.projectInfo"></p>
          <AppButton type="link" size="m" with-icon icon-position="right" isUppercase :href="wine?.projectLink"  :text="wine?.code !=='25-years'?'смотреть проект':'Подробнее о Sminex'" target="_blank" >
            <template #right>
              <IconDefault name="arrow-right-long" :size="'m'" is-circled></IconDefault>
            </template>
          </AppButton>
          <div v-if="isMobile" class="next-page">
            <AppButton  size="xs" type="link" with-icon icon-position="right" :text="pagesStore.getNextWine.title" @click="selectPage(pagesStore.getNextWine.code)">
              <template #right><IconDefault name="chevron-right" size="s"/> </template>
            </AppButton>
          </div>
        </div>
        <div class="row__item slider">
            <AppSlider v-if="wine?.images.length > 0 " :images="wine?.images"></AppSlider>
            <template v-if="wine?.video">
              <video class="video" muted autoplay loop playsinline>
                <source :src="wine?.video" type="video/mp4">
              </video>
            </template>
        </div>
      </div>
    <div class="row wine">
      <div class="row__item wine-photo">
        <div class="image">
          <img :src="wine?.image" :alt="wine?.title">
        </div>
        <div v-if="isMobile" class="wine-info">
          <div class="title" v-html="wine?.title" />
          <div class=" subtitle" v-html="wine?.wine" />
        </div>
      </div>
      <div class="row__item">
        <div v-if="!isMobile" class="title uppercase" v-html="wine?.wine">
        </div>
        <div class="information">
          <div class="information__item" v-if="wine?.information?.category">
            Категория: {{ wine?.information?.category }}
          </div>

          <div class="information__item" v-if="wine?.information?.about" v-html="wine?.information?.about" />
          <div class="information__item" v-if="wine?.information?.glass" v-html="wine?.information?.glass" />

        </div>
        <AppButton v-if="wine?.routeLink" type="link" size="m" with-icon icon-position="right" isUppercase :href="wine?.routeLink"  text="построить маршрут<br> до винотеки" target="_blank" >
          <template #right>
            <IconDefault name="arrow-right-long" :size="'m'" is-circled></IconDefault>
          </template>
        </AppButton>

      </div>
    </div>
    </div>
  </div>
</template>
<script setup lang="ts">
import type { Props } from './model';
import {storeToRefs} from "pinia";
import {usePagesStore} from "@stores/pages";
import {useLayoutStore} from "@stores/layout";
import AppButton from "@components/AppButton/index.vue";
import IconDefault from "@components/AppIcon/index.vue";
import AppSlider from "@components/Slider/index.vue";


defineOptions({
  name:'AppWine'
});
const props = defineProps<Props>();
const layoutStore = useLayoutStore();
const pagesStore = usePagesStore();
const { isMobile } = storeToRefs(layoutStore)


const selectPage = (code:string)=>{
  pagesStore.setPage(code)
}

</script>
<style scoped lang="scss">
.wine-page {
  padding: var(--space-30) var(--space-60) var(--space-60) var(--space-60);

  background-size: contain;
  @media screen and (max-width: 769px) {
    padding: var(--space-20);
  }
  .container {
    display: flex;
    flex-direction: column;
    .row {
      display: flex;
      &.first{
        margin-bottom: var(--space-60);
      }
      @media screen and (max-width: 769px) {
        flex-direction: column;
        margin-bottom: var(--space-10);
        &.first {
          order: 2;
          margin-bottom: 0;
        }
        &.wine{
          order: 0;
          padding: 0;
        }
      }

      &__item {
        width: 50%;
        video {
          margin-top: -5rem;
        }
        @media screen and (max-width: 769px) {
          width: 100%;
          &.wine-photo{
            display: flex;
            align-items: center;
            padding: var(--space-16);
            border: 1px solid var(--color-primary-ghost-30);
            border-radius: var(--border-radius-xxs);
            margin-bottom: var(--space-30);
            .image{
              width: 10rem;
              flex-shrink: 0;
              img{
                width: 100%;
                height: 15rem;
                object-fit: cover;
              }
            }
            .wine-info{
              margin-left: var(--space-20);
              .title{
                font-family: var(--ff-secondary);
                font-size: var(--font-size-32);
                line-height: var(--font-size-28);
              }
              .subtitle{
                font-size: var(--font-size-14);
              }
            }
          }
          video {
            margin-top: 0;
            pointer-events: none;

            &::-webkit-media-controls {
              display: none !important;
            }

            &::-webkit-media-controls-start-playback-button {
              display: none !important;
            }
          }
          &.slider {
            width: calc(100% + var(--space-40));
            transform: translateX(-2rem);
            order: 0;
            margin-bottom: var(--space-30);
          }
          &.project-info{
            order: 1;
          }

        }

        p {
          padding: 2.9rem 2rem 2.4rem 0;
          @media screen and (max-width: 769px) {
            padding: 0;
            font-size: var(--font-size-14);
          }
        }

        img {
          width: 100%;
          object-fit: cover;
          height: 32rem;
        }

        .title {
          font-size: var(--font-size-24);
          line-height: var(--font-size-28);
          color: var(--color-secondary);
          font-family: var(--ff-heading);
          margin-bottom: var(--space-24);

          &.uppercase {
            text-transform: uppercase;
          }

          @media screen and (max-width: 769px) {
            font-size: var(--font-size-20);
            line-height: var(--font-size-22);
            margin-bottom: var(--space-14);
          }
        }

        .information {
          &__item {
            margin-bottom: var(--space-12);

            &:last-child {
              margin-bottom: var(--space-24);
            }
          }
        }

      }

      .next-page {
        margin-top: var(--space-50);
      }

    }
  }
}
</style>